var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path10, _g2, _path11, _path12, _path13, _path14, _stop, _stop2, _feFlood, _feColorMatrix, _feOffset, _feGaussianBlur, _feComposite, _feColorMatrix2, _feBlend, _feBlend2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgDropzoneIcon(props) {
  const _id2 = useUniqueInlineId();
  const _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 284,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    filter: `url(#${_id2})`
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.48 72.506C113.288 38.383 51.426 40.601 27.428 52.258l-2.224-5.357C45.523 31.014 99.707 8.45 153.898 45.306c54.192 36.857 24.157 37.679.582 27.2z",
    fill: `url(#${_id})`
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.182 89.607c3.818-24.895 26.031-42.844 51.187-41.333l1.589 51.563-52.776-10.23z",
    fill: "#fff",
    stroke: "#ED6C47",
    strokeWidth: 6.095
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M189.042 47.538l.539 51.204 23.085 5.842 22.261-4.783 1.284-3.22-47.169-49.043zm0 0c26.26 1.356 47.089 22.806 47.169 49.041l-47.169-49.04z",
    fill: "#fff",
    stroke: "#FF8F6B",
    strokeWidth: 6.095
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M139.105 100.768h97.039c-1.315 26.333-22.352 47.125-47.957 47.203h-1.126c-25.605-.078-46.642-20.87-47.956-47.203z",
    fill: "#fff",
    stroke: "#D35230",
    strokeWidth: 6.095
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M185.96 72.51v50.419c-.021 2.627-2.192 4.751-4.877 4.771h-37.975c-6.789-8.86-10.455-19.637-10.446-30.71v-1.147c-.015-9.988 2.968-19.76 8.581-28.103h39.84c2.685.02 4.856 2.144 4.877 4.77z",
    fill: "#000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M182.629 72.51v50.419c-.02 2.627-2.163 4.751-4.813 4.771h-34.845a50.839 50.839 0 01-10.309-30.71v-1.147a50.662 50.662 0 018.468-28.103h36.686c2.65.02 4.793 2.144 4.813 4.77z",
    fill: "#000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M130.718 67.74h47.192a4.719 4.719 0 014.719 4.718v47.193a4.72 4.72 0 01-4.719 4.718h-47.192a4.718 4.718 0 01-4.718-4.718V72.458a4.718 4.718 0 014.718-4.718z",
    fill: "#BE3819"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.056 83.766c-2.398-1.944-5.349-2.89-8.326-2.67h-12.076v33.279h5.924v-11.766h5.785a12.78 12.78 0 006.104-1.403c1.67-.853 3.08-2.216 4.058-3.926a11.546 11.546 0 001.429-5.78c.171-2.928-.898-5.78-2.898-7.734zm-9.382 13.76h-5.099V86.246h5.288c3.895 0 5.842 1.834 5.842 5.501.099 1.611-.459 3.188-1.524 4.306-1.287 1.077-2.891 1.601-4.507 1.471z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "dropzoneIcon_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 193,
    y: 127,
    width: 83,
    height: 108
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.631 135.957l-36.275-8.073c-3.521-.784-7.046 1.468-7.833 5.004l-18.125 81.436c-.787 3.536 1.45 7.071 4.971 7.854l55.479 12.348c3.521.784 7.046-1.468 7.833-5.004l13.832-62.149-19.882-31.416z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dropzoneIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.631 135.957l-36.275-8.073c-3.521-.784-7.046 1.468-7.833 5.004l-18.125 81.436c-.787 3.536 1.45 7.071 4.971 7.854l55.479 12.348c3.521.784 7.046-1.468 7.833-5.004l13.832-62.149-12.552-14.04-7.33-17.376z",
    fill: "#F4B400"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M218.693 130.859l35.039 7.798 18.532 29.282-13.558 60.921c-.424 1.905-2.33 3.106-4.196 2.691l-55.479-12.348c-1.866-.415-3.082-2.311-2.658-4.216l18.125-81.437c.424-1.905 2.33-3.107 4.195-2.691z",
    fill: "#fff",
    stroke: "#F4B400",
    strokeWidth: 6.095
  })), /*#__PURE__*/React.createElement("mask", {
    id: "dropzoneIcon_svg__b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 193,
    y: 127,
    width: 83,
    height: 108
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M218.693 130.859l35.039 7.798 18.532 29.282-13.558 60.921c-.424 1.905-2.33 3.106-4.196 2.691l-55.479-12.348c-1.866-.415-3.082-2.311-2.658-4.216l18.125-81.437c.424-1.905 2.33-3.107 4.195-2.691z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 6.095
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dropzoneIcon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.686 173.832l27.74 6.173c1.76.392 2.879 2.159 2.485 3.927l-6.201 27.86c-.393 1.768-2.155 2.894-3.916 2.502l-27.739-6.174c-1.761-.391-2.879-2.158-2.486-3.927l6.201-27.859c.393-1.768 2.156-2.894 3.916-2.502zm-4.417 24.882l25.606 5.699 3.338-15.001-25.605-5.699-3.339 15.001z",
    fill: "#F4B912"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M254.311 155.906L257 143.823l12.013 18.981-12.044-2.681c-1.882-.418-3.086-2.295-2.658-4.217z",
    fill: "#fff",
    stroke: "#F4B400",
    strokeWidth: 6.095
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M255.63 135.958l-.119.536 19.468 30.761.533.119-19.882-31.416z",
    fill: "#fff",
    fillOpacity: 0.1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M253.968 233.99l-55.48-12.347c-3.521-.784-5.757-4.318-4.97-7.854l-.12.536c-.787 3.536 1.45 7.07 4.971 7.853l55.479 12.348c3.521.784 7.046-1.468 7.833-5.004l.119-.536c-.787 3.536-4.312 5.788-7.832 5.004z",
    fill: "#BF360C",
    fillOpacity: 0.2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M256.307 163.099c-3.536-.787-5.761-4.302-4.97-7.854l-.119.536c-.791 3.552 1.433 7.067 4.97 7.854l19.205 4.274.119-.536-19.205-4.274z",
    fill: "#BF360C",
    fillOpacity: 0.1
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 145.74,
    y1: 39.546,
    x2: 44.046,
    y2: 57.11,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F6B",
    stopOpacity: 0.6
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F6B",
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("filter", {
    id: _id2,
    x: -1,
    y: -1,
    width: 319,
    height: 317,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, _feFlood || (_feFlood = /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  })), _feColorMatrix || (_feColorMatrix = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  })), _feOffset || (_feOffset = /*#__PURE__*/React.createElement("feOffset", {
    dy: 24
  })), _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  })), _feComposite || (_feComposite = /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  })), _feColorMatrix2 || (_feColorMatrix2 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  })), _feBlend || (_feBlend = /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2338_12828"
  })), _feBlend2 || (_feBlend2 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2338_12828",
    result: "shape"
  })))));
}
export default SvgDropzoneIcon;